import { urijs } from '@wix/communities-blog-client-common';

export const getVideoEmbedThumbUrl = (oembed: any) => {
  if (!oembed?.thumbnail_url) {
    return '';
  }

  // oembed data is third-party; a malformed URL must not crash the widget render
  try {
    // @ts-expect-error
    return urijs(oembed.thumbnail_url).protocol('').toString();
  } catch {
    return '';
  }
};
